import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import GuestLayout from "@/components/guest/GuestLayout";
import Home from "@/pages/guest/Home";
import HouseInfo from "@/pages/guest/HouseInfo";
import LocalTips from "@/pages/guest/LocalTips";
import Guides from "@/pages/guest/Guides";
import GuideDetail from "@/pages/guest/GuideDetail";
import Help from "@/pages/guest/Help";
import Addons from "@/pages/guest/Addons";
import PackInfo from "@/pages/guest/PackInfo";
import PicnicMap from "@/pages/guest/PicnicMap";
import PackHub from "@/pages/guest/PackHub";
import GuidePage from "@/pages/guest/GuidePage";

import Login from "@/pages/admin/Login";
import AdminLayout from "@/components/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import EditProperty from "@/pages/admin/EditProperty";
import EditRecommendations from "@/pages/admin/EditRecommendations";
import EditGuides from "@/pages/admin/EditGuides";
import EditAddons from "@/pages/admin/EditAddons";
import EditReminders from "@/pages/admin/EditReminders";
import EditReservations from "@/pages/admin/EditReservations";
import EditSettings from "@/pages/admin/EditSettings";
import Analytics from "@/pages/admin/Analytics";
import Orders from "@/pages/admin/Orders";

function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname, search]);
  return null;
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-brand-forest">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster position="top-center" richColors />
          <Routes>
            <Route element={<GuestLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/house-info" element={<HouseInfo />} />
              <Route path="/local-tips" element={<LocalTips />} />
              <Route path="/guides" element={<Guides />} />
              <Route path="/guides/:id" element={<GuideDetail />} />
              <Route path="/help" element={<Help />} />
              <Route path="/add-ons" element={<Addons />} />
            </Route>

            <Route path="/pack/:id" element={<PackInfo />} />
            <Route path="/basket/:id" element={<PackHub />} />
            <Route path="/guide/:id/:idx" element={<GuidePage />} />
            <Route path="/picnic-map/:id" element={<PicnicMap />} />
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="property" element={<EditProperty />} />
              <Route path="recommendations" element={<EditRecommendations />} />
              <Route path="guides" element={<EditGuides />} />
              <Route path="add-ons" element={<EditAddons />} />
              <Route path="orders" element={<Orders />} />
              <Route path="reminders" element={<EditReminders />} />
              <Route path="reservations" element={<EditReservations />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="settings" element={<EditSettings />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
